import { Source as SubscriptionSourceApi } from '@vendasta/billing';

export enum SubscriptionSource {
  Unset = '',
  System = 'System',
  User = 'User',
}

export function subscriptionSourceFromApi(sApi: SubscriptionSourceApi | undefined): SubscriptionSource {
  switch (sApi) {
    case SubscriptionSourceApi.SOURCE_SYSTEM:
      return SubscriptionSource.System;
    case SubscriptionSourceApi.SOURCE_USER:
      return SubscriptionSource.User;
    default:
      return SubscriptionSource.Unset;
  }
}

export function subscriptionSourceToApi(source: SubscriptionSource): SubscriptionSourceApi {
  switch (source) {
    case SubscriptionSource.System:
      return SubscriptionSourceApi.SOURCE_SYSTEM;
    case SubscriptionSource.User:
      return SubscriptionSourceApi.SOURCE_USER;
    default:
      return SubscriptionSourceApi.SOURCE_UNSET;
  }
}
